import React, { useEffect, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import buildingActions from 'actions/buildings/actions'
import Card from 'components/shared/card/vertical'
import Slider from 'react-slick'


const OfficeVenueCard = ({
    fetchBuildingOfficeVenueCard,
    details,
    officeCards: data = {}
}) => {
    const { lastPage, page } = data
    const buildingName = details?.name || ''

    const officeCards = useMemo(() => {
        if (data?.results) {
            return data.results
        }
        return []
    }, [data])

    const slider = useRef()
    const settings = {
        dots: false,
        fade: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    }

    useEffect(() => {
        if (details.id)
            fetchBuildingOfficeVenueCard({ id: details.id, limit: 6, isFirstTimeFetch: true })
    }, [details])


    return (
        !!officeCards.length && <div className="w-full">
            <div className="building-separate mt-8 mb-6"></div>
            <h2 className="text-3xl lato-reg text-center pb-40px mx-auto">Office spaces in {buildingName}</h2>
            <div className="lg:hidden lg:w-0 w-full block h-auto">
                <Slider className="building-slider" ref={slider} {...settings}>
                    {officeCards.map((o) => {
                        return (
                            <div key={o.id} className="">
                                <Card data={o} />
                            </div>
                        )
                    })}
                    {page < lastPage && (
                        <div className=" h-full border border-primary-orange  text-primary-orange rounded-lg flex items-center justify-center">
                            <span
                                className="btn w-full flex justify-center select-none"
                                onClick={() => {
                                    fetchBuildingOfficeVenueCard({ id: details?.id, limit: 6, page: page + 1 })
                                }}
                            >
                                Load more
                            </span>
                        </div>
                    )}
                </Slider>
            </div>

            <div className="hidden w-0 lg:w-full lg:flex flex-wrap items-stretch mx--15px">
                {officeCards.map((o) => {
                    return (
                        <div key={o.id} className="w-full md:w-1/2 xl:w-1/3 mb-6 px-15px">
                            <Card data={o} />
                        </div>
                    )
                })}
                {page < lastPage && (
                    <div className="flex items-center justify-center w-full">
                        <div className="">
                            <div className=" border border-primary-orange  text-primary-orange rounded-lg flex items-center justify-center">
                                <span
                                    className="btn select-none"
                                    onClick={() => {
                                        fetchBuildingOfficeVenueCard({ id: details?.id, limit: 6, page: page + 1 })
                                    }}
                                >
                                    Load more
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </div>
    )
}

OfficeVenueCard.propTypes = {
    details: PropTypes.object,
    city: PropTypes.string,
    fetchBuildingOfficeVenueCard: PropTypes.func,
    places: PropTypes.array,
    officeCards: PropTypes.object,
}

const mapStateToProps = ({ building, places }) => {
    return {
        details: building.public.details,
        places: places.options,
        officeCards: building.public.officesVenueCard
    }
}

const mapDispatchToProps = {
    fetchBuildingOfficeVenueCard: buildingActions.fetchBuildingOfficeVenueCard,
}
export default connect(mapStateToProps, mapDispatchToProps)(OfficeVenueCard)
